import { render, staticRenderFns } from "./TripStats.vue?vue&type=template&id=651efb72"
import script from "./TripStats.vue?vue&type=script&lang=js"
export * from "./TripStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports